import script from "./BspPriceEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BspPriceEditModal.vue?vue&type=script&setup=true&lang=js"

import "./BspPriceEditModal.vue?vue&type=style&index=0&id=76ad1518&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ad1518"]])

export default __exports__